import { render } from "./EstalyGiftCardModal.vue?vue&type=template&id=2fdb1d4a"
import script from "./EstalyGiftCardModal.vue?vue&type=script&lang=js"
export * from "./EstalyGiftCardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__